import StripeRefundComponent from './StripeRefundComponent';
import InvoiceRefundComponent from './InvoiceRefundComponent';
import StripeComponent from './StripeComponent'
import InvoiceComponent from './InvoiceComponent';
import PaypalComponent from './PaypalComponent'

const providerMap = {
  'invoice': {
    'payment': InvoiceComponent,
    'refund': InvoiceRefundComponent
  },
  'stripe': {
    'payment': StripeComponent,
    'refund': StripeRefundComponent
  },
  'paypal': {
    'payment': PaypalComponent
  }
};
export default providerMap;



// WEBPACK FOOTER //
// ./src/components/common/PaymentSelector.js